export const LANGUAGES = ['en-us'];
export const LANGUAGE_DEFAULT = LANGUAGES[0];
